import {reactive} from '@vue/composition-api'

export default function compositionDrop(dropCallback) {
  const compositionDropData = reactive({counterDrag: 0})
  function listen__x__ondragenter(e) {
    e.preventDefault()
    this.compositionDropData.counterDrag++
  }
  function listen__x__ondragleave(e) {
    e.preventDefault()
    this.compositionDropData.counterDrag--
  }
  function listen__x__ondragover(e) {
    e.preventDefault()
  }
  function listen__x__ondrop(e) {
    e.preventDefault()
    this.compositionDropData.counterDrag = 0
    if (e.dataTransfer.files.length == 1)
      dropCallback(e.dataTransfer.files[0])
    else
      this.$q.notify({
        message: '하나의 파일만 드래그 해 주세요.',
        icon: 'announcement',
        color: 'purple'
      })
  }
  return {
    compositionDropData,
    listen__x__ondragenter,
    listen__x__ondragleave,
    listen__x__ondragover,
    listen__x__ondrop
  }
}
